import { render, staticRenderFns } from "./oneGameView.vue?vue&type=template&id=593ad708&scoped=true"
import script from "./oneGameView.vue?vue&type=script&lang=js"
export * from "./oneGameView.vue?vue&type=script&lang=js"
import style0 from "./oneGameView.vue?vue&type=style&index=0&id=593ad708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593ad708",
  null
  
)

export default component.exports